export default "/_next/static/assets/iah-logo_a4de1a3e1824793eb95af42ea9e2504f.webp";